<template>
  <div class="">
    <div class="">
      <div class="w-full">
        <div class="p-4 elshadow heigh-payment rounded-12px bg-white">
          <div class="flex w-full justify-start mt-2">
            <div class="flex w-1/5 justify-center">
              <img
                :src="
                  gateway.logo
                    ? getImage(gateway.logo)
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/Payments/Image 1.png'
                "
                class="pm-imgw"
                :alt="gateway.provider"
              />
            </div>
            <div class="w-4/5 pl-2">
              <div class="flex justify-between items-center pr-4">
                <div class="flex gap-2 items-center">
                  <h3 class="text-lg font-semibold text-dark mb-0 pr-2">
                    {{ gateway.provider }}
                  </h3>
                  <div>
                    <el-tag
                      type="success"
                      class="elchips-py rounded-full px-4 py-1 fsize10"
                      v-if="gateway.isActive"
                    >
                      Active
                    </el-tag>
                    <el-tag
                      type="danger"
                      class="elchips-py rounded-full px-4 py-1 fsize10"
                      v-else
                      >In-Active
                    </el-tag>
                  </div>
                </div>
                <div class="cursor-pointer" v-if="!gateway.isActive">
                  <feather-icon
                    icon="TrashIcon"
                    class="text-gray"
                    svgClasses="w-5 h-5"
                    @click="deletePopup(gateway._id)"
                  />
                </div>
              </div>
              <div class="mt-2">
                <div class="flex gap-2 items-center">
                  <p class="text-black mb-0 font-semibold fsize11">Verfied:</p>
                  <p
                    v-if="gateway.verified === 'Success'"
                    class="text-success mb-0 font-normal fsize11"
                  >
                    {{ gateway.verified }}
                  </p>
                  <p
                    v-else-if="gateway.verified === 'Failed'"
                    class="text-danger mb-0 font-normal fsize11"
                  >
                    {{ gateway.verified }}
                  </p>
                  <p v-else class="text-8f8f8f mb-0 font-normal fsize11">
                    {{ gateway.verified }}
                  </p>
                </div>
              </div>
              <div class="mt-2">
                <div
                  v-if="gateway.provider == 'razorpay'"
                  class="flex gap-2 items-center"
                >
                  <p class="text-black mb-0 font-semibold fsize11">ClientId:</p>
                  <p class="text-8f8f8f mb-0 font-normal fsize11">
                    {{ gateway.clientId }}
                  </p>
                </div>
                <div
                  v-if="gateway.provider == 'payu'"
                  class="flex gap-2 items-center"
                >
                  <p class="text-black mb-0 font-semibold fsize11">PayU Key:</p>
                  <p class="text-8f8f8f mb-0 font-normal fsize11">
                    {{ gateway.key }}
                  </p>
                </div>
              </div>
              <!-- <div class="mt-1">
                <div class="flex gap-2 items-center">
                  <p class="text-black mb-0 font-semibold fsize11">Status:</p>
                  <p class="text-8f8f8f mb-0 font-normal fsize11">
                    {{
                      gateway.status === "Active"
                        ? "Avaliable"
                        : gateway.status === "In-Active"
                        ? "Unavaliable"
                        : "Pending"
                    }}
                  </p>
                </div>
              </div> -->
              <!-- <p
                class="text-primary fsize14 font-medium cursor-pointer mt-4 mb-0"
              >
                Manage Account
              </p> -->
              <div v-if="gateway.provider === 'razorpay'">
                <Razorpay
                  v-if="gateway.verified !== 'Success'"
                  :gateway="gateway"
                  :amount="testAmount"
                  :currency="currency"
                  buttonName="Test"
                />
                <div
                  v-else
                  class="w-full flex items-center gap-3 pt-4 justify-start"
                >
                  <vs-button
                    v-if="gateway.isActive === false"
                    class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
                    @click="handleToggleActiveStatus(gateway)"
                  >
                    {{ gateway.isActive ? "In-Active" : "Active" }}
                  </vs-button>
                </div>
              </div>
              <div v-else-if="gateway.provider === 'payu'">
                <!-- For example -->
                <!-- <Razorpay
                  v-if="gateway.verified !== 'Success'"
                  :gateway="gateway"
                  :amount="testAmount"
                  :currency="currency"
                  buttonName="Test"
                /> -->
                <div
                  v-if="gateway.verified !== 'Success'"
                  class="w-full flex items-center gap-3 pt-4 justify-start"
                >
                  <vs-button
                    :disabled="ClickOnce"
                    class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
                    @click="createTransaction()"
                  >
                    {{ "Test" }}
                  </vs-button>
                </div>
                <div
                  v-else
                  class="w-full flex items-center gap-3 pt-4 justify-start"
                >
                  <vs-button
                    v-if="gateway.isActive === false"
                    class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
                    @click="handleToggleActiveStatus(gateway)"
                  >
                    {{ gateway.isActive ? "In-Active" : "Active" }}
                  </vs-button>
                </div>
              </div>
              <div v-else>
                <div class="w-full flex items-center gap-3 pt-4 justify-start">
                  <vs-button
                    class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
                  >
                    Fall Back
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Razorpay from "./Razorpay.vue";
import { mapState } from "vuex";

export default {
  components: {
    Razorpay,
  },
  props: {
    gateway: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      testAmount: 1,
      currency: "INR",
      ClickOnce: false,
    };
  },

  methods: {
    async createTransaction() {
      this.ClickOnce = true;
      try {
        let payload = {
          transactionStatus: "In-Process",
          transactionMode: "Online",
          transactionType: "payu",
          adminId: this.login._id,
          gatewayId: this.gateway._id,
        };

        console.log(payload);
        const transactionrecord = await this.$store.dispatch(
          "Transaction/createTransaction",
          payload
        );
        this.currTransactionId = transactionrecord.data._id;
        // console.log("TRANSACTIONCREATE:", transactionrecord);
        let gatewayPayload = {
          gatewayId: this.gateway._id,
          transactionId: this.currTransactionId,
          adminId: this.login._id,
        };
        const gatewayRecord = await this.$store.dispatch(
          "Payment/editGateway",
          gatewayPayload
        );

        if (gatewayRecord.code == 200 && transactionrecord.code == 200) {
          this.handleTestPayment(
            transactionrecord.data.transactionId,
            // this.gateway._id
            this.gateway.key,
            this.gateway.salt
          );
        }

        return transactionrecord;
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async handleTestPayment(txnId, key, salt) {
      let payload = {
        amount: 1,
        productinfo: "Test",
        txnId: txnId,
        key: key,
        salt: salt,
      };
      // let loader = this.$loading.show();
      try {
        let data = await this.$store.dispatch("Payment/getPayULink", payload);
        if (data.code == 200) {
          this.ClickOnce = false;
          window.open(data.data.link, "_self");
        }
        // loader.hide();
      } catch (err) {
        console.log(err);
        // loader.hide();
      }
    },
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    injectRazorpay() {
      let divScripts = document.getElementById("load-script");
      let newScript = document.createElement("script");
      newScript.src = "https://checkout.razorpay.com/v1/checkout.js";
      divScripts.appendChild(newScript);
    },
    async deletePopup(gatewayId) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          this.handleDelete(gatewayId);
        }
      });
    },
    async handleDelete(gatewayId) {
      let payload = {
        gatewayId: gatewayId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch("Payment/deleteGateway", payload);
      this.getGateway();
    },
    async getGateway() {
      try {
        let data = await this.$store.dispatch("Payment/getGateway");
      } catch (error) {
        console.log(error);
      }
    },

    async handleToggleActiveStatus(gateway) {
      try {
        let fallback;
        let currActive = await this.$store.dispatch(
          "Payment/getSingleGateway",
          {
            isActive: true,
          }
        );
        let payload = {
          gatewayId: gateway._id,
          isActive: true,
          adminId: this.login._id,
        };
        let updateManyPayload = {
          updateMany: true,
        };
        let data = await this.$store.dispatch(
          "Payment/editGateway",
          updateManyPayload
        );
        if (gateway.isActive === false && data.code === 200) {
          fallback = await this.$store.dispatch("Payment/editGateway", payload);
        } else if (fallback && fallback.code !== 200) {
          let data = await this.$store.dispatch("Payment/editGateway", {
            gatewayId: currActive.data._id,
            isActive: true,
          });
        }

        this.getGateway();
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("Payment", { razorpay: "singlePaymentGateway" }),
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
  },
  mounted() {
    // this.injectRazorpay();
  },
};
</script>
